<template>
  <v-container pa-0>
    <v-dialog v-model="isShowing" max-width="600" persistent>
      <v-card>
        <v-card-title class="editor-title">
          <h2>{{ $vuetify.t('$vuetify.RoleEdit.createRoleDialogTitle') }}</h2>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" ref="formRef">
            <v-text-field
              name="roleName"
              v-model="roleName"
              :rules="roleNameRules"
              :label="$vuetify.t('$vuetify.RoleEdit.createRoleDialogLabel')"
              required
              @keydown.enter.prevent="submit"
            />
            <v-btn
              color="primary"
              @click="submit"
            >{{ $vuetify.t('$vuetify.AdminUsers.formCreate') }}
            </v-btn>
            <v-btn
              @click="hideDialog"
            >{{ $vuetify.t('$vuetify.AdminUsers.formCancel') }}
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: 'RoleAddDialog',
  data () {
    return {
      valid: false,
      isShowing: false,
      roleName: null,
      roleNameRules: [
        v => !!v || 'Name is required'
      ]
    }
  },
  methods: {
    showDialog: function () {
      this.isShowing = true
    },
    hideDialog: function () {
      this.isShowing = false
      this.$refs.formRef.reset()
      this.roleName = ''
    },
    submit: function () {
      if (this.$refs.formRef.validate()) {
        this.$parent.createRole(this.roleName)
        this.hideDialog()
      }
    }
  }
}
</script>

<style scoped>

</style>
